import { useCallback } from 'react';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { Props } from './RichMediaTextEditor';

export const RichMediaTextEditorWrapper: React.FC<Props> = (props) => {
	const loadComponent = useCallback(
		async () =>
			(await import(/* webpackChunkName: "cmp/rich_media_text_editor" */ './RichMediaTextEditor')).RichMediaTextEditor,
		[],
	);

	return <LazyComponent loadComponent={loadComponent} {...props} />;
};
